// trading-api answers for Bybit in Binance's shapes (positions, open orders, closed positions,
// trades, balances), so the frontend reads both alike. Import-free CommonJS, so it can be
// tested in plain node -- see src/lib/sweep-result-config.js for the precedent.
const BINANCE_SHAPED_EXCHANGES = ['binance', 'bybit'];

const isBinanceShaped = exchange => BINANCE_SHAPED_EXCHANGES.includes(exchange);

module.exports = { BINANCE_SHAPED_EXCHANGES, isBinanceShaped };
